if (window.location.pathname.includes("admin/clipboards")) {
    $(window).on("popup_open", function(e, type, data) {
        if (type === "editor-clipboard") {
            if (window.activeEditor) {
                window.activeEditor.setData(data.response.clipboard.email);
            } else {
                window.ClassicEditor.create(
                    document.querySelector("#email-editor"),
                    window.editorConfig
                ).then(editor => (window.activeEditor = editor));
            }
        }
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/clipboards.js